export default __webpack_public_path__ + "static/media/How Deep is Your Love.3c43c1f1.mp3";